/** Route constants for the Commissions module (kept tiny: the shell bundle imports it). */

/** The module root, and the base the pop-out viewer URL is built from. */
export const COMMISSIONS_BASE = '/commissions';

/** The Air tab, where the workbench lives today. A Hotel tab would be a sibling. */
export const COMMISSIONS_AIR_PATH = `${COMMISSIONS_BASE}/air`;
